'use client'

import React from 'react'
import LandingLayout from '@components/Landing/LandingLayout'

const Page = () => {
  return (
    <LandingLayout
      title="Privacy policy"
      limited
      meta={
        <>
          <title>Privacy policy - Enhanci</title>
        </>
      }
    >
      <h1>Enhanci Privacy Policy</h1>
      <p>
        <strong>Effective Date:</strong> 1 November 2025
      </p>

      <p>
        Welcome to <strong>Enhanci.com</strong> (“Enhanci”, “we”, “our”, or “us”).
        <br />
        This Privacy Policy explains how we collect, use, and protect your personal
        information when you use our website, tools, and related services (collectively,
        the “Services”).
        <br />
        By using the Services, you agree to this Privacy Policy.
      </p>

      <h2>1. Information We Collect</h2>

      <h3>1.1 Account Information</h3>
      <p>
        When you create an account, we collect:
        <br />– Your <strong>email address</strong>
        <br />– Your <strong>password</strong> (stored securely in hashed and salted form)
      </p>
      <p>
        We use this information to create and manage your account, authenticate you, and
        provide the Services.
      </p>

      <h3>1.2 Cookies and Session Data</h3>
      <p>
        We use <strong>cookies</strong> and similar technologies to:
        <br />
        – Keep you logged in (authorization cookie)
        <br />
        – Improve website functionality and user experience
        <br />– Analyze site usage and performance
      </p>
      <p>
        You can manage or delete cookies through your browser settings, but some features
        of the Service may not function properly if cookies are disabled.
      </p>

      <h3>1.3 Analytics Data</h3>
      <p>
        We use third-party analytics tools to help us understand how users interact with
        Enhanci:
        <br />– <strong>Google Analytics</strong> (provided by Google LLC)
        <br />– <strong>Microsoft Clarity</strong> (provided by Microsoft Corporation)
      </p>
      <p>
        These tools collect anonymous or pseudonymous data such as pages visited, time
        spent, device type, and browser information. You can learn more and opt out here:
        <br />
        <a
          href="https://tools.google.com/dlpage/gaoptout"
          target="_blank"
          rel="noreferrer"
        >
          Google Analytics Opt-Out
        </a>
        <br />
        <a href="https://privacy.microsoft.com/clarity" target="_blank" rel="noreferrer">
          Microsoft Clarity Privacy Statement
        </a>
      </p>

      <h2>2. How We Use Your Information</h2>
      <p>
        We use your information to:
        <br />
        – Provide and maintain the Services
        <br />
        – Authenticate and manage user accounts
        <br />
        – Improve functionality and performance
        <br />
        – Respond to support requests
        <br />– Ensure security and integrity
      </p>
      <p>
        We <strong>do not sell or trade</strong> your personal information.
      </p>

      <h2>3. Legal Basis for Processing (GDPR)</h2>
      <p>
        If you are located in the EEA or UK, we process your personal data on the
        following bases:
        <br />
        – Contractual necessity
        <br />
        – Legitimate interest
        <br />– Consent (for optional analytics)
      </p>

      <h2>4. Data Storage and Security</h2>
      <p>
        Passwords are stored using <strong>industry-standard hashing</strong> (bcrypt or
        Argon2).
        <br />
        Access to personal data is restricted to authorized personnel only.
        <br />
        We use HTTPS encryption for all communications.
        <br />
        No method of storage or transmission is 100% secure, but we strive to use
        commercially reasonable means to protect your information.
      </p>

      <h2>5. Data Retention</h2>
      <p>
        We retain your data only as long as necessary to provide the Services and comply
        with legal or technical requirements.
        <br />
        If you delete your account, we will remove your data from active systems within a
        reasonable period.
      </p>

      <h2>6. Your Rights</h2>
      <p>
        You may have the following rights:
        <br />
        – Access your data
        <br />
        – Request correction
        <br />
        – Request deletion
        <br />
        – Object to processing
        <br />– Request data portability
      </p>
      <p>
        To exercise your rights, contact us at <strong>inbox@enhanci.com</strong>.
      </p>

      <h2>7. Third-Party Services</h2>
      <p>
        Our Services may include links to external websites or services. We are not
        responsible for their privacy practices or content.
      </p>

      <h2>8. Children’s Privacy</h2>
      <p>
        Enhanci is not intended for individuals under 16. We do not knowingly collect
        personal information from children.
      </p>

      <h2>9. Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. If we make significant
        changes, we will post a notice on our website and update the “Effective Date.”
      </p>

      <h2>10. Contact Us</h2>
      <p>
        If you have any questions about this Privacy Policy, contact us at:
        <br />
        <strong>inbox@enhanci.com</strong>
      </p>
    </LandingLayout>
  )
}

export default Page
